export const purpurIconNameList = [
    'activity-level',
    'add',
    'add-ai',
    'address-book',
    'airplay',
    'alarm-off',
    'alarm-on',
    'alert',
    'alert-filled',
    'android',
    'apple',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-subdirectory',
    'arrow-up',
    'attachment',
    'b2b-customer',
    'bag',
    'bag-ai',
    'bankid',
    'bar-chart',
    'bar-chart-ai',
    'basketball',
    'battery',
    'blood-pressure',
    'bluetooth',
    'bookmark',
    'bookmark-filled',
    'box',
    'box-ai',
    'broadband',
    'broken-phone',
    'bulb',
    'business-continuity',
    'business-intelligence',
    'calendar',
    'camera',
    'card-view',
    'care',
    'cart',
    'cart-ai',
    'cast',
    'chat',
    'chat-ai',
    'chat-filled',
    'chat-robot',
    'chat-single',
    'chat-single-ai',
    'check-circle',
    'check-circle-filled',
    'checkmark',
    'checkmark-bold',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'child-1',
    'child-2',
    'close',
    'close-circle',
    'cloud',
    'cloud-connect',
    'coffee',
    'compass',
    'connected',
    'connected-building',
    'construction',
    'conversation',
    'cookie',
    'copy',
    'copy-filled',
    'core-router',
    'credit-card',
    'customer-dialogue',
    'daas-device',
    'data-transfer',
    'delivery',
    'desktop',
    'devices',
    'devices-ai',
    'dislike',
    'dislike-filled',
    'doc',
    'doc-ai',
    'document-doc',
    'document-edit',
    'document-excel',
    'document-pdf',
    'document-ppt',
    'download',
    'drag-horizontal',
    'drag-vertical',
    'drone',
    'dsl-hub',
    'edit',
    'edit-ai',
    'education',
    'efficiency',
    'email',
    'end-user',
    'end-user-ai',
    'entertainment',
    'environment',
    'error',
    'error-filled',
    'esim',
    'esim-simcard',
    'euro',
    'external',
    'face-id',
    'facebook',
    'facemask',
    'fiber',
    'film',
    'filter',
    'fingerprint',
    'fiveg',
    'flag',
    'focus',
    'folder',
    'folder-copy',
    'folder-new',
    'food',
    'fourg',
    'fraud',
    'games',
    'getting-started',
    'gif',
    'google',
    'graph',
    'graph-ai',
    'grid-view',
    'handshake',
    'headphones',
    'heart',
    'heart-filled',
    'help',
    'home',
    'home-care',
    'home-filled',
    'home-installation',
    'hospital',
    'hourglass',
    'image',
    'industrial-iot',
    'industry',
    'infinite',
    'info',
    'info-filled',
    'instagram',
    'internet',
    'invisible',
    'invoice',
    'invoice-ai',
    'invoice-filled',
    'it-service',
    'job-search',
    'kai-os',
    'key',
    'kontantkort',
    'kr',
    'laptop',
    'late-payment',
    'layers',
    'letter',
    'like',
    'like-filled',
    'link',
    'linkedin',
    'list-view',
    'lock',
    'lock-open',
    'login',
    'logout',
    'map',
    'maximize',
    'measuring-health',
    'media-content',
    'megaphone',
    'menu',
    'microphone',
    'minimize',
    'minus',
    'minus-bold',
    'mms',
    'mobile-broadband',
    'moisture',
    'money-back-euro',
    'money-back-kr',
    'money-euro',
    'money-kr',
    'monitoring-iot',
    'moon',
    'more-horizontal',
    'more-horizontal-filled',
    'more-vertical',
    'move',
    'music',
    'mute',
    'network',
    'new-contact',
    'new-contact-ai',
    'new-group',
    'news',
    'offering',
    'offshore',
    'oneplus',
    'optimization',
    'org-chart',
    'parental-guide',
    'password-invisible',
    'password-visible',
    'pay-installments-euro',
    'pay-installments-kr',
    'pay-monthly-euro',
    'pay-monthly-kr',
    'pay-once-euro',
    'pay-once-kr',
    'payment-success',
    'pebble',
    'pebble-ai',
    'people',
    'people-hub',
    'pet-dog',
    'phone',
    'phone-recycling',
    'phone-ringing',
    'pie-chart',
    'pin',
    'plane',
    'play',
    'play-filled',
    'player-settings',
    'plus',
    'plus-ai',
    'plus-minus',
    'police',
    'portal',
    'power-grid',
    'premises',
    'premises-datacenter',
    'premises-large',
    'premises-medium',
    'premises-small',
    'present',
    'press-button',
    'price',
    'print',
    'pulse',
    'qr-code',
    'question',
    'question-filled',
    'rack',
    'radio',
    'record',
    'recycle',
    'refill-card',
    'register',
    'remote-control',
    'remove',
    'remove-ai',
    'remove-filled',
    'repair',
    'repair-ai',
    'report',
    'report-ai',
    'resend',
    'reservation',
    'reverse',
    'roaming',
    'robot',
    'robot-ai',
    'route',
    'router',
    'ruler',
    'samsung',
    'satellite',
    'save',
    'save-ai',
    'savings',
    'scan',
    'search',
    'search-ai',
    'secure-device',
    'secured-1',
    'secured-2',
    'security-camera',
    'send',
    'send-ai',
    'sense-car',
    'server',
    'service-device',
    'service-supervision',
    'services',
    'settings',
    'settings-ai',
    'share',
    'shopping',
    'shopping-ai',
    'shuffle',
    'signature',
    'simcard',
    'skip-back-10sec',
    'skip-back-30sec',
    'skip-forward-10sec',
    'skip-forward-30sec',
    'slow-wifi',
    'smart-wifi',
    'smartphone',
    'smartwatch',
    'smiley-happy',
    'smiley-sad',
    'sms',
    'snapchat',
    'snowflake',
    'sorter',
    'sorter-ai',
    'sparkles',
    'speedometer',
    'spell-check',
    'split',
    'spyware',
    'star',
    'star-filled',
    'stop',
    'store',
    'stream',
    'suitcase',
    'suitcase-ai',
    'summary',
    'sun',
    'support',
    'support-ai',
    'sustainability',
    'switch-arrows',
    'sync',
    'sync-ai',
    'table-view',
    'tablet',
    'tag',
    'temperature',
    'thinking',
    'time',
    'trade-phone',
    'trailer',
    'train',
    'transfer',
    'troubleshoot',
    'tv',
    'tv-next',
    'tv-pause',
    'tv-previous',
    'tv-stop',
    'undo',
    'unpin',
    'upload',
    'usb',
    'user-admin',
    'vcard',
    'video',
    'video-conference',
    'visible',
    'voice-switch',
    'voicemail',
    'volume',
    'wallet',
    'wallplug',
    'warning',
    'wavelength',
    'weather',
    'whatsapp',
    'windows',
    'wireless',
    'wireless-off',
    'wireless-weak',
    'world',
    'world-alert',
    'world-off',
    'world-question',
    'x',
    'xiaomi',
    'youtube',
    'zoom',
    'zoom-out',
];
